import type { Socket } from 'socket.io-client'
import { createSocket } from '@/lib/player-socket'

let crashSocket: Socket | null = null

export function getCrashSocket(): Socket {
	if (!crashSocket) {
		crashSocket = createSocket({
			namespace: '/crash-game',
		})
	}

	return crashSocket
}

export function disconnectCrashSocket(): void {
	if (!crashSocket) {
		return
	}

	crashSocket.removeAllListeners()
	crashSocket.disconnect()
	crashSocket = null
}
